import { render, staticRenderFns } from "./ProductSectionAttributes.vue?vue&type=template&id=043430cc&scoped=true"
import script from "./ProductSectionAttributes.vue?vue&type=script&lang=js"
export * from "./ProductSectionAttributes.vue?vue&type=script&lang=js"
import style0 from "./ProductSectionAttributes.vue?vue&type=style&index=0&id=043430cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043430cc",
  null
  
)

export default component.exports